import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { EntryMethod } from 'src/common/enumerations/entry-method';
import { IItemHierarchyLookup } from 'src/common/interfaces/dtos/IItemHierarchyLookup';
import { IItemLookup } from 'src/common/interfaces/dtos/IItemLookup';
import { IPromotionLookup } from 'src/common/interfaces/dtos/IPromotionLookup';
import { IPriceCheckState } from 'src/common/interfaces/states/IPriceCheckState';

const initialState: IPriceCheckState = {
  queryQuantity: 1,
};

class PriceCheckResponseReducer extends ImmerReducer<IPriceCheckState> {
  public setItemState(
    itemLookup: IItemLookup,
    queryQuantity: number,
    isManualWeight?: boolean,
    entryMethod?: EntryMethod,
    itemCode?: string,
  ): void {
    this.draftState = {
      ...this.draftState,
      itemLookup,
      queryQuantity,
      isManualWeight,
      entryMethod,
      itemCode
    };
  }


  public setItemPromotions(promotions: IPromotionLookup[]): void {
    this.draftState = { ...this.draftState, promotions };
  }

  public setItemHierarchy(hierarchy: IItemHierarchyLookup[]): void {
    this.draftState = { ...this.draftState, hierarchy };
  }

  public resetState() {
    this.draftState = initialState;
  }
}

export const PriceCheckActions = createActionCreators(PriceCheckResponseReducer);
export const PriceCheckReducerFunction = createReducerFunction(
  PriceCheckResponseReducer,
  initialState,
);
